import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Partial } from 'lodash';
import {
    BaseControl,
    Textbox,
    TextArea,
    ParametroFiltro,
    Container,
    Custom,
    DateTimePicker
  } from '@app/shared';


@Injectable()
export class FlowFormService {
  constructor() {}

  /**
   * Crea el formulario dinamico de los filtros del reporte
   *
   * @param {ParametroFiltro[]} columns
   * @param {*} templetesForm
   * @returns {BaseControl<any>[]}
   * @memberof FlowFormService
   */
  getFieldsFilterReportStructure(
    columns: ParametroFiltro[],
    templetesForm: any
  ): BaseControl<any>[] {

    const controls: BaseControl<any>[] = [new Container({
      class: 'form-row form-check form-check-inline col-12',
      order: 1,
      controls: [ ]
    })];

    columns.forEach(field => {
      controls[0]['controls'].push(this.getControl(field, templetesForm));
    });

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el control de pendiendo del tipo
   *
   * @param {ParametroFiltro} control
   * @param {*} templetesFomr
   * @param {*} [value]
   * @returns {BaseControl<Partial>}
   * @memberof FlowFormService
   */
  private getControl(
    control: ParametroFiltro,
    templetesFomr: any,
  ): BaseControl<Partial> {
    let field: any;
    switch (control.tipo_campo.nombre) {
      case 'textarea':
        const textArea: TextArea = new TextArea({
          key: control.id,
          label: control.label,
          size: 'col-md-' + control.espacio,
          rows: '4',
          placeholder: control.label,
          value: null,
          order: control.orden,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          textArea.validations.validators.push(Validators.required);
        }

        field = textArea;
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/)],
            messages: {
              email: 'Por favor introduce un email válido.'
            }
          },
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.id,
          label: control.label,
          order: control.orden,
          value: null,
          size: 'col-md-' + control.espacio,
          pickerMode: 'dialog',
          placeholder: control.label,
          pickerType: 'calendar',
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }
        // Queda pendiente por definir la estructura
        // switch (control.propiedades['tipo']) {
        //   case 'calendar':
        //     date.pickerType = 'calendar';
        //     break;
        //   case 'timer':
        //     date.pickerType = 'timer';
        //     break;
        //   case 'range':
        //     date.selectMode = 'range';
        //     break;
        //   case 'rangeTime':
        //     date.pickerType = 'timer';
        //     date.selectMode = 'range';
        //     break;
        //   case 'rangeDate':
        //     date.pickerType = 'calendar';
        //     date.selectMode = 'range';
        //     break;
        // }
        field = date;
        break;
      case 'ngSelect':
        const ngSelect: Custom = new Custom({
          key: control.id,
          label: control.label,
          order: control.orden,
          size: 'col-md-' + control.espacio,
          template: templetesFomr.ngSelectTpl,
          placeholder: control.label,
          value: null,
          options: control['options'] ? control['options'] : [],
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden + 1,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        field = number;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden + 1,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        field = text;
        break;
    }
    return field;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/shared/flow.form.service.ts